import OptionSeparator from '@/src/common/components/elements/Layout/OptionSeparator'
import { useBasicGiftCardContext } from '@/src/common/contexts/BasicGiftCardContext'
import {
    CARRIER_FONT_STANDARD,
    CARRIER_TYPE_GREETING_CARD,
    CARRIER_TYPE_STANDARD,
    GREETING_CARD_FEE,
} from '@/src/modules/build-a-card/constants'
import DetailedOptionButton from '@/src/modules/gift-box/buttons/DetailedOptionButton'
import { BuildACardStep, SimpleFieldWrapper } from '../StepElement'
import { HeaderParagraphText } from '@/src/modules/build-a-card/StyledComponents'

export const PhysicalOpenLoopCarrierSelectionStep = () => {
    const {
        currentStep,
        setCurrentStep,
        carrierType,
        setCarrierType,
        setFontSelection,
    } = useBasicGiftCardContext()

    const handleSelection = (type: string) => {
        setCarrierType(type)
        setCurrentStep(3)
    }

    return (
        <BuildACardStep id={'step-greeting-card'} active={currentStep === 2}>
            <SimpleFieldWrapper>
                <HeaderParagraphText>Choose one:</HeaderParagraphText>
                <DetailedOptionButton
                    header={'Greeting Card – 4.25" x 5.5"'}
                    description={
                        'Choose from over 50 designs. White envelope included!'
                    }
                    image={'/images/greeting-card-pieces.png'}
                    altText={'Greeting card image'}
                    onClick={() => {
                        handleSelection(CARRIER_TYPE_GREETING_CARD)
                    }}
                    imageWidth={133}
                    imageHeight={166}
                    isActive={carrierType === CARRIER_TYPE_GREETING_CARD}
                    headerFontSize={'1.05rem'}
                    blueText={`+ $${GREETING_CARD_FEE.toFixed(2)}`}
                />
                <OptionSeparator padding={'0px 7%'} />
                <DetailedOptionButton
                    header={'Standard Carrier – 8.5" x 11"'}
                    description={
                        'A tri-fold paper carrier. Mail to yourself or your recipient.'
                    }
                    image={'/images/carrier-image.png'}
                    altText={'Tri-fold carrier image'}
                    onClick={() => {
                        handleSelection(CARRIER_TYPE_STANDARD)
                        setFontSelection(CARRIER_FONT_STANDARD)
                    }}
                    imageWidth={133}
                    imageHeight={166}
                    isActive={carrierType === CARRIER_TYPE_STANDARD}
                    headerFontSize={'1.05rem'}
                    blueText={'FREE'}
                />
            </SimpleFieldWrapper>
        </BuildACardStep>
    )
}
